import React from 'react';
import cx from 'classnames';

import {Text, type TextProps} from '../../elements/Text/Text';

import styles from './Captions.module.scss';
import {FontVariant} from '../../..';

export type CaptionsProps = {
    captions?: string;
    speakers?: string[];
    timestamp?: string;
};

export const Captions: React.FC<CaptionsProps & TextProps> = ({
    captions,
    speakers,
    className,
    timestamp,
    ...props
}) => {
    if (!captions) {
        return null;
    }

    return (
        <div className={cx(styles.captionsContainer, className)}>
            {(speakers || timestamp) && (
                <div className={styles.captionsTitle}>
                    {speakers && (
                        <Text
                            fontVariant={FontVariant.BodyBold}
                            translate="no"
                            className={styles.speakers}
                            htmlTag="p"
                            isTruncated
                        >
                            {speakers.join(', ')}
                        </Text>
                    )}
                    {timestamp && (
                        <Text
                            variant="standard"
                            htmlTag="p"
                            fontVariant={FontVariant.Small}
                            className={styles.timestamp}
                        >
                            {timestamp}
                        </Text>
                    )}
                </div>
            )}
            <Text
                variant="standard"
                htmlTag="p"
                className={cx(styles.captions)}
                {...props}
            >
                {captions}
            </Text>
        </div>
    );
};
